
import React,{useState} from 'react';
import Router from './Router';
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  split,
  HttpLink,
} from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import GlobalContextProvider from './Component/GlobalContextProvider';

const createApolloClient = (authToken) => {
  const httpLink = new HttpLink({
    uri: "https://selected-pipefish-60.hasura.app/v1/graphql",
    headers: {
      "x-hasura-admin-secret": authToken,
    },
  });

  const wsLink = new WebSocketLink({
    uri: "wss://selected-pipefish-60.hasura.app/v1/graphql",
    options: {
      lazy: true,
      reconnect: true,
      timeout: 5000,
      connectionParams: {
        headers: {
          "x-hasura-admin-secret": authToken,
        },
      },
    },
  });

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
      },
      query: {
        fetchPolicy: "network-only",
      },
    },
  });
};



function App() {
  const [client] = useState(
    createApolloClient(process.env.REACT_APP_HASURA_ADMIN_SECRET)
  );

  return (
    <ApolloProvider client={client}>
    <div className="App">
      <GlobalContextProvider>
        <Router />
      </GlobalContextProvider>
    </div>
    </ApolloProvider>
  );
}

export default App;
